import React from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
const RadioInput = (props) => {
    const { formInputsProps } = props
    const [value, setValue] = React.useState();

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <div className="col-12 form-group radio-btn">
            <FormControl>
                <FormLabel className={`${formInputsProps.responseData.theme}_label`} id="demo-controlled-radio-buttons-group">{formInputsProps?.formField?.is_mandatory ? '*' : null} {formInputsProps?.formField?.input}</FormLabel>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group" className={formInputsProps.responseData.theme}
                    value={formInputsProps.formValues[formInputsProps?.formField?.input] = value ? value : null}
                    onChange={handleChange}
                >
                    <>
                        {
                            formInputsProps?.formField?.value.map(list => {
                                return <FormControlLabel value={list.value} className="word-break-all" control={<Radio />} label={list.key} />            
                            })
                        }
                    </>
                </RadioGroup>
            </FormControl>
            {
                
                formInputsProps.formValues[formInputsProps.formField?.input] && !formInputsProps.formErrors[formInputsProps.formField?.input] ? null : 
                <p className="errMsg"> {!value ? formInputsProps.formErrors[formInputsProps.formField?.input] : null} </p>
            }
        </div>
    );
}

export default RadioInput